import React from "react";
import styled from "@emotion/styled";
import { BrowserRouter as Router } from "react-router-dom";

import { NavHeader } from "./components/NavHeader";
import { Body } from "./components/Body";
import { ScreenSizeProvider } from "./components/ScreenSizeContext";
import headerImage from "./images/header-image.png";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #00000b;
`;

const BodyContainer = styled.div`
  margin-top: 12%;
  width: 100%;
  flex: 1.5;
  z-index: 1;
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

function App() {
  return (
    <Router>
      <ScreenSizeProvider>
        <Container>
          <BackgroundImage src={headerImage} />
          <NavHeader />
          <BodyContainer>
            <Body />
          </BodyContainer>
        </Container>
      </ScreenSizeProvider>
    </Router>
  );
}

export default App;
